import React, { useState } from 'react';
import { FinalEnPlainNums } from './finalEnPlainNums';
import { PlainSplitHolder } from './plainSpliteHolder';
import {doChipStore} from "../../../store/doChipStore";
import {useRouletteDoBetValidation} from "../../../hooks/useRouletteDoBetValidation";
import {CombinationTypes} from "../../../enums/tableNumbers";
import {observer} from "mobx-react-lite";
import { useTranslation } from '@pascal/pascal-core';

export const FinalEnPlain = observer(() => {
  const [ isOpenFinalBetSection, setIsOpenFinalBetSection ] = useState(false);
  const {selectedChip} = doChipStore;
  const t = useTranslation();
  const { handleDoBetInCombination } = useRouletteDoBetValidation();

  const handleDoChip = (e) => {
    const valueType = e.target.getAttribute("data");
    const model = CombinationTypes[valueType];
    if (model) {
      if (selectedChip) {
        handleDoBetInCombination(model, selectedChip, valueType);
      }
    }
  };
  return (
    <div className={`mob-r-finale-plein ${isOpenFinalBetSection ? 'open' : ''}`}> {/*add/remove open class*/}
      <div className="mob-r-finale-plein-ins">
        <p className="mob-finale-plein-title">{t('FINALE_EN_PLEIN')}</p>
        <FinalEnPlainNums handleDoChip={handleDoChip}/>
        <p className="mob-finale-plein-title">{t('SPLITS')}</p>
        <p className="mob-finale-plein-title">{t('SNAKE_BETS')}</p>
        <PlainSplitHolder handleDoChip={handleDoChip}/>
      </div>
      <div className="finale-plein-arrow left" onClick={() => setIsOpenFinalBetSection(false)}/>
      <div className="finale-plein-arrow right" onClick={() => setIsOpenFinalBetSection(true)}/>
    </div>
  );
});
